import { Check } from 'lucide-react';
import type { Platform } from '@multimod/shared';
import { PlatformIcon } from '@/components/ui/platform-icon';

export function DestinationChip({
  platform,
  active,
  onToggle,
}: {
  platform: Platform;
  active: boolean;
  onToggle: () => void;
}) {
  const label = platform === 'twitch' ? 'Twitch' : 'YouTube';
  const activeCls =
    platform === 'twitch'
      ? 'bg-platform-twitch-soft text-platform-twitch border-platform-twitch'
      : 'bg-platform-youtube-soft text-platform-youtube border-platform-youtube';
  // #110: inactive mais leve (bg-bg-card + border-strong) que o antigo chumbado
  // (bg-bg-muted); rounded-full conforme prototype (screen-panel-1.html .dest-chip).
  const cls = active ? activeCls : 'bg-bg-card text-fg-muted border-border-strong';
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full border text-xs font-medium transition-colors duration-fast ${cls}`}
    >
      {active && <Check size={11} strokeWidth={2.5} />}
      <PlatformIcon platform={platform} size={12} />
      <span>{label}</span>
    </button>
  );
}
